import { useEffect } from "react";

import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";

type DJLandingPageProps = {};

/**
 * Immediately routes the Car Owner to the first actual page of the Digital Journey flow.
 *
 * The DJ Car Owner will always land on `/:sessionId` and then be immediately
 * redirected to the first page.
 */
export const DJLandingPage: React.FC<DJLandingPageProps> = () => {
  const { onNext } = useDigitalJourneyPageRouting();

  useEffect(() => {
    onNext();
  }, [onNext]);
  return <></>;
};
